import Spinner from 'src/javascripts/components/utilities/Spinner';
import {companiesBloodhound, fundsBloodhound, filterTypeahead, filterTypeaheadNoCache} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {genericDisplayTemplate, logoTemplate, noResultsTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class DashboardsEdit {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');
    const dashboardId = $('.form-section').attr('data-dashboard-id');

    // Reloading //
    const reloadPage = function() {
      $('.modal-body').css('opacity', 0.2);
      if ( $('.modal-content').find('.spinner-container').length === 0 ) {
        Spinner($('.modal-content'));
      }
      let baseUrl = window.location.pathname;
      Turbo.clearCache(); 
      Turbo.visit(baseUrl);
    }

    // Select dashboard type
    $('.select-record-type').change(function() {
      let dashboardableType = $(this).val();
      $('.dashboardable-search').addClass('d-none');
      $('.dashboardable-search[data-dashboardable-type=\'' + dashboardableType + '\']').removeClass('d-none');
      if (dashboardableType !== '') {
        $('#dashboardableTypeSelected').removeClass('border-0 p-0');
      } else {
        $('#dashboardableTypeSelected').addClass('border-0 p-0');
      }
      if (dashboardableType === 'Issuer') {
        $('.restrict-to-portfolio-row').removeClass('d-none');
      } else {
        $('.restrict-to-portfolio-row').addClass('d-none');
        $('#hidden_restrict_to_portfolio_id').val('');
        $('#restrict_portfolio_search').typeahead('val', '');
      }
    })

    if ($('#featured_portfolio_search').length > 0) {
      let params = {};
      filterTypeahead('#featured_portfolio_search', 'portfolios', '/' + accountUrl + '/portfolios?' + $.param(params), 256, 'generic');
    }
    if ($('#featured_fund_search').length > 0) {
      let params = {};
      filterTypeahead('#featured_fund_search', 'funds', '/funds?' + $.param(params), 42, 'logo');
    }
    if ($('#featured_company_search').length > 0) {
      let params = {};
      filterTypeahead('#featured_company_search', 'companies', '/companies?' + $.param(params), 42, 'logo');
    }

    // Clear company and reload on click of clear button
    $('#clearDashboardCompany').click(function(ev, suggestion) {
      $('#featured_company_search').val('');
      $('#featured_company_search').typeahead('val', '');
      $('#featured_company_search').focus();
      $('input[type=\'submit\']').attr('disabled', true);
    });

    // Clear fund and reload on click of clear button
    $('#clearDashboardFund').click(function(ev, suggestion) {
      $('#featured_fund_search').val('');
      $('#featured_fund_search').typeahead('val', '');
      $('#featured_fund_search').focus();
      $('input[type=\'submit\']').attr('disabled', true);
    });

    // Clear portfolio and reload on click of clear button
    $('#clearDashboardPortfolio').click(function(ev, suggestion) {
      $('#featured_portfolio_search').val('');
      $('#featured_portfolio_search').attr('data-clear-portfolios', 'true');
      reloadPage();
    });


  }
}